import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { OrderRefund } from '../../../models/refund';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderedService } from 'src/app/services/ordered.service';


/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-refund-dialog',
  templateUrl: './refund-dialog.component.html',
  styleUrls: ['./refund-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class RefundDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public spinner: boolean = false;
  public done: boolean;
  public currentOrderRefund: OrderRefund;



  constructor(
    private fb: FormBuilder,
    private _orderedService: OrderedService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.currentOrderRefund = this.data.orderRefund;
    this.done = this.data.done;

  }


  ngOnInit() {

    this._adapter.setLocale('pt');

    this.entityForm = this.createForm()
    this.setFormValues(this.currentOrderRefund, this.entityForm)
  }


  updateRefund() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: OrderRefund = this.createEntity(this.entityForm.value);

      this._orderedService.updateRefund(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("refund update error: " + JSON.stringify(error))
          let msgError: string = this._orderedService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });

    }
  }

  createEntity(data: any): OrderRefund {
    let entity = new OrderRefund();

    entity.order_id = data.order_id;
    entity.account = data.account;
    entity.agency = data.agency;
    entity.bank = data.bank;
    entity.bankName = data.bankName;
    entity.dateRequest = data.dateRequest;
    entity.discount = data.discount;
    entity.total = data.total;

    if (data.dateRefund)
      entity.dateRefund = data.dateRefund
    else
      entity.dateRefund = new Date();

    return entity;
  }

  setFormValues(data, form) {
    form.controls.order_id.setValue(data.order_id);
    form.controls.account.setValue(data.account);
    form.controls.agency.setValue(data.agency);
    form.controls.bank.setValue(data.bank);
    form.controls.bankName.setValue(data.bankName);
    form.controls.discount.setValue(data.discount);
    form.controls.total.setValue(data.total);

    if (data.dateRequest) {
      let dt = new Date(data.dateRequest.seconds * 1000)
      form.controls.dateRequest.setValue(dt);
    }

    if (data.dateRefund) {
      let dt = new Date(data.dateRefund.seconds * 1000)
      form.controls.dateRefund.setValue(dt);
    }

  }

  createForm() {
    let form: FormGroup = this.fb.group({
      order_id: new FormControl('', [Validators.required]),
      account: new FormControl('', [Validators.required]),
      agency: new FormControl('', [Validators.required]),
      bank: new FormControl('', [Validators.required]),
      bankName: new FormControl('', [Validators.required]),
      dateRequest: new FormControl('', [Validators.required]),
      dateRefund: new FormControl(''),
      discount: new FormControl('', [Validators.required]),
      total: new FormControl('', [Validators.required]),

    });
    return form
  }


}

